import { iUser } from "../../interfaces/iUser";
import { CallEmsApi, iEmsApiResponseBody } from "../../Logic/EmsAPI/FetchExtension";
import { productivityReport, slaReport, summaryReport } from "./interfaces";

export async function GetProductivityReportData(
    filters: summaryReport,
): Promise<iEmsApiResponseBody<productivityReport>> {
    let mofidiedFilters = { ...filters };
    mofidiedFilters.serviceCentres = []; // we adding this override becayse based on discussions with Wazeer on 3 Nov 2025 service center filter should not be applied
    return await CallEmsApi<any>("POST", "Reporting/GetProductivityReportData", mofidiedFilters);
}

export async function GetUsers(): Promise<iEmsApiResponseBody<{ users: iUser[] }>> {
    return await CallEmsApi<any>("GET", "Users");
}

export async function GetDepartments(): Promise<iEmsApiResponseBody<{ items: { id: number; name: "string" }[] }>> {
    return await CallEmsApi<any>("GET", "Departments");
}

export async function GetSLAReportData(
    filters: summaryReport,
): Promise<iEmsApiResponseBody<{ responseCycleSLAReportData: Array<slaReport> }>> {
    let mofidiedFilters = { ...filters };
    mofidiedFilters.serviceCentres = []; // we adding this override becayse based on discussions with Wazeer on 3 Nov 2025 service center filter should not be applied
    return await CallEmsApi<any>("POST", "Reporting/GetResponseCycleSLAReportData", filters);
}
export async function GetSLACSVReportData(
    filters: summaryReport,
): Promise<iEmsApiResponseBody<{ responseCycleSLADetailedReportData: Array<slaReport> }>> {
    let mofidiedFilters = { ...filters };
    mofidiedFilters.serviceCentres = []; // we adding this override becayse based on discussions with Wazeer on 3 Nov 2025 service center filter should not be applied
    return await CallEmsApi<any>("POST", "Reporting/GetResponseCycleSLADetailedReportData", filters);
}
